import { call } from 'rise-ui/utils/function.js';

export function iif(expr, onTruthy = true, onFalsy = false) {
  const on = expr ? onTruthy : onFalsy;
  return call(on, on, expr);
}
